import styled, { css } from 'styled-components';
import { NAV_HEIGHT_MOBILE, NAV_HEIGHT_DESKTOP, BREAKPOINT_DESKTOP } from '../constants';

export { default as BackButton } from './BackButton';
export { default as HeaderMenu } from './HeaderMenu';
export { default as MenuToggler } from './MenuToggler';
export { default as HeaderLogoLink } from './HeaderLogoLink';

export const HeaderWrapper = styled.div<{ isSticky: boolean }>`
  display: flex;
  justify-content: space-between;
  top: 0;
  position: ${(props) => (props.isSticky ? 'fixed' : 'relative')};
  background-color: #fefefe;
  top: 0;
  right: 0;
  left: 0;
  z-index: 10000;
  @media ${BREAKPOINT_DESKTOP} {
    position: ${(props) => (props.isSticky ? 'fixed' : 'relative')};
  }
`;

export const HeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: ${NAV_HEIGHT_MOBILE}px;
  position: relative;
  z-index: 1;
  @media ${BREAKPOINT_DESKTOP} {
    flex-grow: 2;
    width: auto;
    height: ${NAV_HEIGHT_DESKTOP}px;
    box-shadow: none;
  }
`;

export const SignUpButtonContainer = styled.div<{ isVisible: boolean; isSticky: boolean }>`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  transition: top 0.2s, opacity 0.2s;
  @media ${BREAKPOINT_DESKTOP} {
    display: none;
  }
  ${(props) =>
    !props.isSticky &&
    css`
      display: none;
    `}
  ${(props) =>
    props.isVisible
      ? css`
          top: -100%
          opacity: 1;
        `
      : css`
          top: 0;
          opacity: 0;
        `};
`;

export const SwapContainer = styled.div`
  flex-direction: column;
  width: 100%;
  height: 100%;
  overflow: hidden;
  @media ${BREAKPOINT_DESKTOP} {
    flex-grow: 1;
    width: auto;
  }
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/Header/components/index.tsx